// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    JW_NEWEST_VIDEO_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_NEWEST_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.jwNewestVideo
      };
    },
    JW_NEWEST_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwNewestVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
